module.exports = __webpack_public_path__ + "img/icon-tw.2d0b286a.svg";